export default "__VITE_ASSET__CDhVCdlv__"